import React from 'react'
import styled from 'styled-components'

interface MarkdownContentProps {
  children: React.ReactNode
  style?: React.CSSProperties
  className?: string
}

const StyledMarkdownContent = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  line-height: 1.7;
  color: ${({ theme }) => theme.colors.Grey60};

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ theme }) => theme.colors.MidnightBlue};
    margin: ${({ theme }) => theme.space.sm}px 0
      ${({ theme }) => theme.space.xxs}px 0;
  }

  h1 {
    font-size: 24px;
  }
  h2 {
    font-size: 20px;
  }
  h3 {
    font-size: 18px;
    font-weight: 600;
  }
  h4 {
    font-size: 16px;
    font-weight: 600;
  }

  p {
    margin: 0 0 ${({ theme }) => theme.space.xs}px 0;
  }

  ul,
  ol {
    margin: 0 0 ${({ theme }) => theme.space.xs}px 0;
    padding-left: ${({ theme }) => theme.space.sm}px;
  }

  li {
    margin-bottom: ${({ theme }) => theme.space.xxs}px;
  }

  strong {
    color: ${({ theme }) => theme.colors.MidnightBlue};
    font-weight: 600;
  }

  a {
    color: ${({ theme }) => theme.colors.Violet};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`

export function MarkdownContent({
  children,
  style,
  className,
}: MarkdownContentProps) {
  return (
    <StyledMarkdownContent style={style} className={className}>
      {children}
    </StyledMarkdownContent>
  )
}
